<template>
  <donut v-if="elevators" :data="chartData" :pie="pie" :centerText="chartCenterText" @segment-click="onSegmentClick">
  </donut>
</template>

<script>
import api from './api.js'
import auth from './auth.js'

import Donut from './DonutChart.vue'
import formatter from './formatter.mixin.js'

export default {
  name: 'elevators-status-chart',
  props: ['elevators', 'pie', 'groupId'],
  components: {
    'donut': Donut,
  },
  mixins: [formatter],
  data() {
    return {
    }
  },
  computed: {
    poweroff: function () {
      return this.elevators.filter(e => e.status == 9);
    },
    evac: function () {
      return this.elevators.filter(e => e.status == 8);
    },
    alarm: function () {
      return this.elevators.filter(e => e.status == 7);
    },
    fire: function () {
      return this.elevators.filter(e => e.status == 6);
    },

    error: function () {
      return this.elevators.filter(e => e.status == 5);
    },

    shutdown: function () {
      return this.elevators.filter(e => e.status == 4);
    },

    operationalOffline24h: function () {
      return this.elevators.filter(e => e.status == 3);
    },

    operationalOffline2h: function () {
      return this.elevators.filter(e => e.status == 2);
    },

    operationalOnline: function () {
      return this.elevators.filter(e => e.status == 1);
    },

    unknown: function () {
      return this.elevators.filter(e => e.status == 0);
    },

    repair: function () {
      return this.elevators.filter(e => e.status == -1);
    },

    maintenanceOffline24h: function () {
      return this.elevators.filter(e => e.status == -2);
    },

    inspectionOffline24h: function () {
      return this.elevators.filter(e => e.status == -3);
    },

    maintenanceOffline2h: function () {
      return this.elevators.filter(e => e.status == -4);
    },

    inspectionOffline2h: function () {
      return this.elevators.filter(e => e.status == -5);
    },

    maintenanceOnline: function () {
      return this.elevators.filter(e => e.status == -6);
    },

    inspectionOnline: function () {
      return this.elevators.filter(e => e.status == -7);
    },

    chartData: function () {
      var labels = [];
      var data = [];
      var colors = [];
      var statuses = [];

      data.push(this.poweroff.length);       labels.push(this.nameForStatus(9));  colors.push('#cc3300'); statuses.push(9);
      data.push(this.evac.length);           labels.push(this.nameForStatus(8));  colors.push('#cc3300'); statuses.push(8);
      data.push(this.alarm.length);          labels.push(this.nameForStatus(7));  colors.push('#cc3300'); statuses.push(7);
      data.push(this.fire.length);           labels.push(this.nameForStatus(6));  colors.push('#cc3300'); statuses.push(6);
      data.push(this.error.length);          labels.push(this.nameForStatus(5));  colors.push('#cc3300'); statuses.push(5);
      data.push(this.shutdown.length);       labels.push(this.nameForStatus(4));  colors.push('#ff9999'); statuses.push(4);
      data.push(this.operationalOffline24h.length); labels.push(this.nameForStatus(3)); colors.push('#ff9900'); statuses.push(3);
      data.push(this.operationalOffline2h.length);  labels.push(this.nameForStatus(2)); colors.push('#ffff33'); statuses.push(2);
      data.push(this.operationalOnline.length);     labels.push(this.nameForStatus(1)); colors.push('#00cc33'); statuses.push(1);
      data.push(this.unknown.length);        labels.push(this.nameForStatus(0));  colors.push('#cccccc'); statuses.push(0);
      data.push(this.repair.length);         labels.push(this.nameForStatus(-1)); colors.push('#cc99ff'); statuses.push(-1);
      data.push(this.maintenanceOffline24h.length); labels.push(this.nameForStatus(-2)); colors.push('#cc99ff'); statuses.push(-2);
      data.push(this.inspectionOffline24h.length);  labels.push(this.nameForStatus(-3)); colors.push('#cc99ff'); statuses.push(-3);
      data.push(this.maintenanceOffline2h.length);  labels.push(this.nameForStatus(-4)); colors.push('#cc99ff'); statuses.push(-4);
      data.push(this.inspectionOffline2h.length);   labels.push(this.nameForStatus(-5)); colors.push('#cc99ff'); statuses.push(-5);
      data.push(this.maintenanceOnline.length);     labels.push(this.nameForStatus(-6)); colors.push('#0099ff'); statuses.push(-6);
      data.push(this.inspectionOnline.length);      labels.push(this.nameForStatus(-7)); colors.push('#0099ff'); statuses.push(-7);

      return [
        {
          labels: labels,
          data: data,
          backgroundColor: colors,
          statuses: statuses,
        }
      ]
    },
    chartCenterText: function () {
      return "";
    },
  },
  methods: {
    onSegmentClick(index) {
      const dataset = this.chartData[0];
      if (!dataset || dataset.data[index] === 0) return;
      const status = dataset.statuses[index];
      if (this.groupId) {
        this.$router.push('/groups/' + this.groupId + '?status=' + status);
      } else {
        this.$router.push('/lifts?status=' + status);
      }
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/ElevatorsStatusChartSimple.vue